/** @jsx jsx */
import { css, jsx } from '@emotion/core';

import { Button, Spacer } from '@zapier/design-system';
import { urlWithNext } from '@zapier/url-utils';

import Surface from '../../shared/Surface';
import { SizeType } from '../../../types';

type LoginBlockProps = {
  /** Function to call when user clicks 'Log in'. Just for tracking as the component will deal with actually logging in. */
  onClickLogIn: () => void;
  /** Function to call when user clicks 'Sign Up'. Just for tracking as the component will deal with actually signing up. */
  onClickSignUp: () => void;
  /** Size to display. */
  size?: SizeType;
};

const gridCss = css`
  display: grid;
  grid-gap: 10px;
  grid-template-columns: repeat(auto-fit, minmax(0, min-content));
`;

/**
 * Renders the login block.
 */
const LoginBlock = ({
  onClickLogIn,
  onClickSignUp,
  size = 'large',
}: LoginBlockProps) => {
  const next = `${window.location.pathname}${window.location.search}`;

  return (
    <Surface size={size} title="Log in for better support!">
      <p>
        Do you have a Zapier account or are you managing someone else's Zapier
        account? If so, logging in will let us help you better and faster. We
        can only assist with specific Zaps, Transfers, and Developer
        integrations if you're logged in to an account that has access to the
        one(s) you need assistance with. That way we can see your logs and
        confirm account ownership for security.
      </p>
      <Spacer height={13} />
      <div css={gridCss}>
        <Button
          color="primary"
          href={urlWithNext('/app/login', next)}
          onClick={onClickLogIn}
        >
          Log in
        </Button>{' '}
        <Button
          color="secondary"
          href={urlWithNext('/sign-up/', next)}
          onClick={onClickSignUp}
        >
          Sign Up
        </Button>
      </div>
    </Surface>
  );
};

export default LoginBlock;
